(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hibana-immersive-collection"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hicReady==='true')return;root.dataset.hicReady='true';root.classList.add('js-ready');const bar=root.querySelector('[data-hic-product-bar]');const setBar=()=>bar&&bar.classList.toggle('is-scrolled',window.scrollY>180);setBar();window.addEventListener('scroll',setBar,{passive:true});root.querySelectorAll('[data-hic-slider]').forEach(slider=>{const track=slider.querySelector('[data-hic-track]');const slides=[...slider.querySelectorAll('[data-hic-slide]')];const current=slider.querySelector('[data-hic-current]');const dots=[...slider.querySelectorAll('.hic-progress i')];const update=()=>{if(!track||!slides.length)return;const left=track.scrollLeft;let active=0;let distance=Infinity;slides.forEach((slide,index)=>{const value=Math.abs(slide.offsetLeft-left);if(value<distance){distance=value;active=index}});if(current)current.textContent=String(active+1);dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===active))};slider.querySelectorAll('[data-hic-next]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.88,behavior:'smooth'})));slider.querySelectorAll('[data-hic-previous]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.88,behavior:'smooth'})));track&&track.addEventListener('scroll',update,{passive:true});update()});root.querySelectorAll('[data-hic-dialog-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=root.querySelector(`#${CSS.escape(button.dataset.hicDialogOpen)}`);dialog&&dialog.showModal()}));root.querySelectorAll('[data-hic-dialog]').forEach(dialog=>{dialog.querySelectorAll('[data-hic-dialog-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()})});root.querySelectorAll('[data-hic-look-explorer]').forEach(explorer=>{const buttons=[...explorer.querySelectorAll('[data-hic-look-button]')];const stages=[...explorer.querySelectorAll('[data-hic-look-stage]')];buttons.forEach(button=>button.addEventListener('click',()=>{const index=button.dataset.hicLookButton;buttons.forEach(item=>item.setAttribute('aria-checked',String(item===button)));stages.forEach(stage=>stage.classList.toggle('is-hidden',stage.dataset.hicLookStage!==index))}))});const reveal=[...root.querySelectorAll('[data-hic-reveal]')];const observer=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle('is-visible',entry.isIntersecting)),{rootMargin:'0px 0px -8% 0px',threshold:.08});reveal.forEach(element=>observer.observe(element));const videos=[...root.querySelectorAll('video')];const videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;if(entry.isIntersecting){video.play().catch(()=>{})}else{video.pause()}}),{rootMargin:'200px 0px',threshold:.05});videos.forEach(video=>videoObserver.observe(video))};document.querySelectorAll('[data-hic-root]').forEach(init);document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-hic-root]')))} )();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-inventory-status"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function readJson(root, selector, fallback) {
      const source = root.querySelector(selector);
      if (!source) return fallback;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return fallback;
      }
    }

    function getVariantId() {
      const productFormInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (productFormInput && productFormInput.value) {
        return String(productFormInput.value);
      }

      const url = new URL(window.location.href);
      return url.searchParams.get('variant');
    }

    function resolveStatus(variant, override, lowStockThreshold) {
      if (override && override !== 'auto') {
        return override;
      }

      if (!variant) {
        return 'not_available';
      }

      const quantity = Number(variant.inventory_quantity || 0);

      if (!variant.inventory_management) {
        return 'in_stock';
      }

      if (quantity > 0) {
        if (quantity <= lowStockThreshold) {
          return 'low_stock';
        }

        return 'in_stock';
      }

      if (variant.inventory_policy === 'continue') {
        return 'pre_order';
      }

      if (variant.available) {
        return 'in_stock';
      }

      return 'out_of_stock';
    }

    function init(root) {
      if (root.dataset.hibanaInventoryInitialized === 'true') return;

      const variantData = readJson(root, '[data-hibana-inventory-variants]', []);
      const copy = readJson(root, '[data-hibana-inventory-copy]', {});
      const label = root.querySelector('.hibana-inventory-status__label');
      const message = root.querySelector('.hibana-inventory-status__message');
      const override = root.dataset.statusOverride || 'auto';
      const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
      let lastVariantId = null;

      function update() {
        const variantId = getVariantId();
        const variant = variantData.find((item) => String(item.id) === String(variantId)) || variantData[0];
        const status = resolveStatus(variant, override, lowStockThreshold);

        if (String(variantId) === String(lastVariantId) && status === root.dataset.currentStatus) {
          return;
        }

        const content = copy[status] || copy.not_available;
        if (!content) return;

        lastVariantId = variantId;
        root.dataset.currentStatus = status;
        root.style.setProperty('--hibana-stock-current', content.color);
        if (label) label.textContent = content.label;
        if (message) message.textContent = content.message;
      }

      update();
      document.addEventListener('change', update);
      document.addEventListener('variant:change', update);
      document.addEventListener('product:variant-change', update);
      window.setInterval(update, 500);
      root.dataset.hibanaInventoryInitialized = 'true';
    }

    function placeInProductMain(root) {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const productInfo = productForm?.closest('.t4s-product__info-container') || document.querySelector('.t4s-product__info-container');
      const oldStatus = productInfo?.querySelector('.t4s-liquid_custom_liquid_UhMfUm, [class*="liquid_custom_liquid_UhMfUm"]') || document.querySelector('.t4s-liquid_custom_liquid_UhMfUm, [class*="liquid_custom_liquid_UhMfUm"]');
      const hurryBlock = productInfo?.querySelector('[class*="inventory_qty_xFtete"], .t4s-inventory_qty') || document.querySelector('[class*="inventory_qty_xFtete"], .t4s-inventory_qty');

      if (oldStatus && oldStatus.parentNode && oldStatus !== root && !oldStatus.contains(root)) {
        oldStatus.parentNode.insertBefore(root, oldStatus);
        oldStatus.style.display = 'none';
        return;
      }

      if (hurryBlock && hurryBlock.parentNode && hurryBlock !== root && !hurryBlock.contains(root)) {
        hurryBlock.parentNode.insertBefore(root, hurryBlock.nextSibling);
        return;
      }

      if (productInfo && root.parentNode !== productInfo) {
        productInfo.appendChild(root);
      }
    }

    function initAll() {
      document.querySelectorAll('.hibana-inventory-status').forEach((root) => {
        placeInProductMain(root);
        init(root);
      });
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-product-tech-anatomy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root = document) => {
      root.querySelectorAll('[data-tech-anatomy]').forEach((section) => {
        if (section.dataset.techAnatomyReady === 'true') return;
        section.dataset.techAnatomyReady = 'true';

        const hotspots = Array.from(section.querySelectorAll('[data-tech-hotspot]'));

        const closeAll = (returnFocus = false) => {
          hotspots.forEach((hotspot) => {
            const marker = hotspot.querySelector('[data-tech-marker]');
            const popover = hotspot.querySelector('[data-tech-popover]');
            const wasOpen = hotspot.classList.contains('is-active');
            hotspot.classList.remove('is-active');
            marker.setAttribute('aria-expanded', 'false');
            popover.hidden = true;
            if (returnFocus && wasOpen) marker.focus();
          });
        };

        const openHotspot = (index) => {
          closeAll(false);
          const hotspot = hotspots[index];
          if (!hotspot) return;
          const marker = hotspot.querySelector('[data-tech-marker]');
          const popover = hotspot.querySelector('[data-tech-popover]');
          hotspot.classList.add('is-active');
          marker.setAttribute('aria-expanded', 'true');
          popover.hidden = false;
        };

        hotspots.forEach((hotspot, index) => {
          const marker = hotspot.querySelector('[data-tech-marker]');
          const closeButton = hotspot.querySelector('[data-tech-close]');
          const nextButton = hotspot.querySelector('[data-tech-next]');

          marker.addEventListener('click', () => {
            if (hotspot.classList.contains('is-active')) {
              closeAll(true);
            } else {
              openHotspot(index);
            }
          });

          closeButton.addEventListener('click', () => closeAll(true));
          nextButton.addEventListener('click', () => {
            const nextIndex = (index + 1) % hotspots.length;
            openHotspot(nextIndex);
            hotspots[nextIndex].querySelector('[data-tech-marker]').focus({ preventScroll: true });
          });
        });

        section.addEventListener('click', (event) => {
          if (!event.target.closest('[data-tech-hotspot]')) closeAll(false);
        });

        section.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeAll(true);
        });
      });
    };

    initialise();
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-product-tech-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root = document) => {
      root.querySelectorAll('[data-tech-features]').forEach((section) => {
        if (section.dataset.techFeaturesReady === 'true') return;
        section.dataset.techFeaturesReady = 'true';
        section.classList.add('js-ready');

        const chapters = section.querySelectorAll('[data-tech-reveal]');
        const videos = section.querySelectorAll('video');

        if (!('IntersectionObserver' in window)) {
          chapters.forEach((chapter) => chapter.classList.add('is-visible'));
          return;
        }

        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.1 });

        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play().catch(() => {});
            } else {
              entry.target.pause();
            }
          });
        }, { rootMargin: '160px 0px', threshold: 0.05 });

        chapters.forEach((chapter) => revealObserver.observe(chapter));
        videos.forEach((video) => videoObserver.observe(video));
      });
    };

    initialise();
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-durability"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hsdReady)return;root.dataset.hsdReady="true";const track=root.querySelector("[data-hsd-track]"),slides=[...root.querySelectorAll("[data-hsd-slide]")],dots=[...root.querySelectorAll(".hibana-story-durability__footer i")];if(!track||!slides.length)return;const update=()=>{let active=0,distance=Infinity;slides.forEach((slide,index)=>{const value=Math.abs(slide.offsetLeft-track.scrollLeft);if(value<distance){distance=value;active=index}});dots.forEach((dot,index)=>dot.classList.toggle("is-active",index===active))};root.querySelector("[data-hsd-next]")?.addEventListener("click",()=>track.scrollBy({left:track.clientWidth*.9,behavior:"smooth"}));root.querySelector("[data-hsd-prev]")?.addEventListener("click",()=>track.scrollBy({left:-track.clientWidth*.9,behavior:"smooth"}));track.addEventListener("scroll",update,{passive:true});update()};document.querySelectorAll("[data-hibana-durability]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-durability]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-finale"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hsfnReady)return;root.dataset.hsfnReady="true";const track=root.querySelector("[data-hsfn-track]"),slides=[...root.querySelectorAll("[data-hsfn-slide]")],dots=[...root.querySelectorAll(".hibana-story-finale__controls i")];if(!track||!slides.length)return;const update=()=>{let active=0,distance=Infinity;slides.forEach((slide,index)=>{const value=Math.abs(slide.offsetLeft-track.scrollLeft);if(value<distance){distance=value;active=index}});dots.forEach((dot,index)=>dot.classList.toggle("is-active",index===active))};root.querySelector("[data-hsfn-next]")?.addEventListener("click",()=>track.scrollBy({left:track.clientWidth*.9,behavior:"smooth"}));root.querySelector("[data-hsfn-prev]")?.addEventListener("click",()=>track.scrollBy({left:-track.clientWidth*.9,behavior:"smooth"}));track.addEventListener("scroll",update,{passive:true});update()};document.querySelectorAll("[data-hibana-finale]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-finale]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-fit-system"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hsfReady)return;root.dataset.hsfReady="true";root.querySelectorAll("[data-hsf-open]").forEach(button=>button.addEventListener("click",()=>root.querySelector(`#${CSS.escape(button.dataset.hsfOpen)}`)?.showModal()));root.querySelectorAll("[data-hsf-dialog]").forEach(dialog=>{dialog.querySelector("[data-hsf-close]")?.addEventListener("click",()=>dialog.close());dialog.addEventListener("click",event=>{if(event.target===dialog)dialog.close()})})};document.querySelectorAll("[data-hibana-fit]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-fit]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-hero"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hsReady)return;root.dataset.hsReady="true";const nav=root.querySelector("[data-hibana-story-nav]");const update=()=>nav&&nav.classList.toggle("is-scrolled",window.scrollY>160);update();window.addEventListener("scroll",update,{passive:true})};document.querySelectorAll("[data-hibana-story-hero]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-story-hero]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-highlights"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hshReady)return;root.dataset.hshReady="true";const track=root.querySelector("[data-hsh-track]"),slides=[...root.querySelectorAll("[data-hsh-slide]")],current=root.querySelector("[data-hsh-current]"),dots=[...root.querySelectorAll(".hibana-story-highlights__progress i")];if(!track||!slides.length)return;const update=()=>{let active=0,distance=Infinity;slides.forEach((slide,index)=>{const value=Math.abs(slide.offsetLeft-track.scrollLeft);if(value<distance){distance=value;active=index}});if(current)current.textContent=String(active+1);dots.forEach((dot,index)=>dot.classList.toggle("is-active",index===active))};root.querySelector("[data-hsh-next]")?.addEventListener("click",()=>track.scrollBy({left:track.clientWidth*.9,behavior:"smooth"}));root.querySelector("[data-hsh-prev]")?.addEventListener("click",()=>track.scrollBy({left:-track.clientWidth*.9,behavior:"smooth"}));track.addEventListener("scroll",update,{passive:true});update()};document.querySelectorAll("[data-hibana-highlights]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-highlights]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-looks"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hslReady)return;root.dataset.hslReady="true";const buttons=[...root.querySelectorAll("[data-hsl-button]")],stages=[...root.querySelectorAll("[data-hsl-stage]")];buttons.forEach(button=>button.addEventListener("click",()=>{const index=button.dataset.hslButton;buttons.forEach(item=>item.setAttribute("aria-checked",String(item===button)));stages.forEach(stage=>stage.classList.toggle("is-hidden",stage.dataset.hslStage!==index))}))};document.querySelectorAll("[data-hibana-looks]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-looks]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-story-performance"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.hspReady)return;root.dataset.hspReady="true";root.classList.add("js-ready");const track=root.querySelector("[data-hsp-track]"),slides=[...root.querySelectorAll("[data-hsp-slide]")],current=root.querySelector("[data-hsp-current]");if(track&&slides.length){const update=()=>{let active=0,distance=Infinity;slides.forEach((slide,index)=>{const value=Math.abs(slide.offsetLeft-track.scrollLeft);if(value<distance){distance=value;active=index}});if(current)current.textContent=String(active+1)};root.querySelector("[data-hsp-next]")?.addEventListener("click",()=>track.scrollBy({left:track.clientWidth*.88,behavior:"smooth"}));root.querySelector("[data-hsp-prev]")?.addEventListener("click",()=>track.scrollBy({left:-track.clientWidth*.88,behavior:"smooth"}));track.addEventListener("scroll",update,{passive:true});update()}root.querySelectorAll("[data-hsp-open]").forEach(button=>button.addEventListener("click",()=>root.querySelector(`#${CSS.escape(button.dataset.hspOpen)}`)?.showModal()));root.querySelectorAll("[data-hsp-dialog]").forEach(dialog=>{dialog.querySelector("[data-hsp-close]")?.addEventListener("click",()=>dialog.close());dialog.addEventListener("click",event=>{if(event.target===dialog)dialog.close()})});const reveal=root.querySelectorAll("[data-hsp-reveal]");const observer=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle("is-visible",entry.isIntersecting)),{threshold:.08});reveal.forEach(element=>observer.observe(element));const videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>entry.isIntersecting?entry.target.play().catch(()=>{}):entry.target.pause()),{rootMargin:"160px 0px",threshold:.05});root.querySelectorAll("video").forEach(video=>videoObserver.observe(video))};document.querySelectorAll("[data-hibana-performance]").forEach(init);document.addEventListener("shopify:section:load",event=>init(event.target.querySelector("[data-hibana-performance]")))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-tech-immersive-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroVideo = (scope = document) => {
      scope.querySelectorAll("[data-ht-video-toggle]").forEach((button) => {
        if (button.dataset.htReady === "true") return;
        const section = button.closest(".hibana-tech-hero");
        const video = section?.querySelector("video");
        if (!video) return;
        button.dataset.htReady = "true";
        button.addEventListener("click", () => {
          const shouldPlay = video.paused;
          if (shouldPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
          const label = shouldPlay ? button.dataset.pauseLabel : button.dataset.playLabel;
          button.setAttribute("aria-label", label);
          button.querySelector("[data-ht-motion-label]").textContent = label;
          button.querySelector("[data-ht-motion-icon]").textContent = shouldPlay ? "Ⅱ" : "▶";
        });
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          video.pause();
          button.setAttribute("aria-label", button.dataset.playLabel);
          button.querySelector("[data-ht-motion-label]").textContent = button.dataset.playLabel;
          button.querySelector("[data-ht-motion-icon]").textContent = "▶";
        }
      });
    };
    initHeroVideo();
    document.addEventListener("shopify:section:load", (event) => initHeroVideo(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-tech-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTechnologyNavigation = (scope = document) => {
      scope.querySelectorAll("[data-ht-nav]").forEach((nav) => {
        if (nav.dataset.htReady === "true") return;
        nav.dataset.htReady = "true";
        const links = [...nav.querySelectorAll("[data-ht-nav-link]")];
        const track = nav.querySelector(".hibana-tech-nav__track");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        let ticking = false;

        const getHeaderOffset = () => {
          const candidates = [
            document.querySelector(".hibana-unified-header"),
            document.querySelector(".hibana-my-vehicle-mobile"),
            document.querySelector(".t4s-header__wrapper"),
            document.querySelector(".t4s-section-header")
          ].filter(Boolean);
          const visibleBottoms = candidates.map((header) => {
            const rect = header.getBoundingClientRect();
            if (rect.bottom <= 0 || rect.top < -1 || rect.top > 180 || rect.height > 220) return 0;
            return Math.min(rect.bottom, 220);
          });
          const measured = Math.max(0, ...visibleBottoms);
          return measured || Number.parseFloat(getComputedStyle(nav).getPropertyValue("--ht-nav-fallback")) || 0;
        };

        const getHeaderMenuHeight = () => {
          const candidates = [
            document.querySelector(".hibana-unified-header"),
            document.querySelector(".t4s-header__wrapper"),
            document.querySelector(".t4s-section-header")
          ].filter(Boolean);
          const visibleHeights = candidates.map((header) => {
            const rect = header.getBoundingClientRect();
            if (rect.bottom <= 0 || rect.top < -1 || rect.top > 180 || rect.height < 40 || rect.height > 140) return 0;
            return rect.height;
          });
          return Math.max(0, ...visibleHeights) || 60;
        };

        const syncDimensions = () => {
          const headerOffset = Math.round(getHeaderOffset());
          const menuHeight = Math.round(getHeaderMenuHeight());
          document.documentElement.style.setProperty("--ht-header-offset", `${headerOffset}px`);
          document.documentElement.style.setProperty("--ht-menu-height", `${menuHeight}px`);
          document.documentElement.style.setProperty("--ht-nav-height", `${Math.round(nav.offsetHeight)}px`);
        };

        const activate = (link, centerLink) => {
          if (!link || link.classList.contains("is-active")) return;
          links.forEach((item) => {
            const active = item === link;
            item.classList.toggle("is-active", active);
            if (active) {
              item.setAttribute("aria-current", "true");
            } else {
              item.removeAttribute("aria-current");
            }
          });
          if (centerLink && track && track.scrollWidth > track.clientWidth) {
            const left = link.offsetLeft - ((track.clientWidth - link.offsetWidth) * .5);
            track.scrollTo({ left, behavior: reducedMotion.matches ? "auto" : "smooth" });
          }
        };

        const updateActive = () => {
          syncDimensions();
          const line = getHeaderOffset() + nav.offsetHeight + Math.min(window.innerHeight * .28, 220);
          let activeLink = links[0];
          links.forEach((link) => {
            const target = document.getElementById(link.dataset.target);
            if (target && target.getBoundingClientRect().top <= line) activeLink = link;
          });
          activate(activeLink, false);
          ticking = false;
        };

        const requestUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateActive);
        };

        links.forEach((link) => {
          link.addEventListener("click", (event) => {
            const target = document.getElementById(link.dataset.target);
            if (!target) return;
            event.preventDefault();
            const applyState = () => activate(link, true);
            if (document.startViewTransition && !reducedMotion.matches) {
              document.startViewTransition(applyState);
            } else {
              applyState();
            }
            syncDimensions();
            const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - nav.offsetHeight + 1;
            window.scrollTo({ top, behavior: reducedMotion.matches ? "auto" : "smooth" });
          });
        });

        window.addEventListener("scroll", requestUpdate, { passive: true });
        window.addEventListener("resize", requestUpdate, { passive: true });
        updateActive();
      });
    };
    initTechnologyNavigation();
    document.addEventListener("shopify:section:load", (event) => initTechnologyNavigation(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-tech-pin"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTechnologyPins = (scope = document) => {
      scope.querySelectorAll("[data-ht-pin]").forEach((pin) => {
        if (pin.dataset.htReady === "true") return;
        pin.dataset.htReady = "true";
        pin.classList.add("is-enhanced");
      });

      if (window.__hibanaTechnologyPinListener) return;
      window.__hibanaTechnologyPinListener = true;
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      let ticking = false;

      const update = () => {
        document.querySelectorAll("[data-ht-pin]").forEach((pin) => {
          const desktopPin = window.matchMedia("(min-width: 1200px) and (min-height: 700px)").matches;
          if (!desktopPin || reducedMotion.matches) {
            pin.style.setProperty("--ht-pin-media-left", "0%");
            pin.style.setProperty("--ht-pin-copy-opacity", "1");
            pin.style.setProperty("--ht-pin-copy-y", "0px");
            pin.style.setProperty("--ht-pin-shade", ".72");
            return;
          }
          const rect = pin.getBoundingClientRect();
          const viewport = window.innerHeight;
          const distance = Math.max(pin.offsetHeight - viewport, 1);
          const progress = Math.min(1, Math.max(0, -rect.top / distance));
          const copyProgress = Math.min(1, Math.max(0, (progress - .22) / .5));
          pin.style.setProperty("--ht-pin-media-left", `${(42 * (1 - progress)).toFixed(2)}%`);
          pin.style.setProperty("--ht-pin-copy-opacity", copyProgress.toFixed(3));
          pin.style.setProperty("--ht-pin-copy-y", `${(34 * (1 - copyProgress)).toFixed(2)}px`);
          pin.style.setProperty("--ht-pin-shade", (.24 + (.5 * progress)).toFixed(3));
        });
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate, { passive: true });
      update();
    };
    initTechnologyPins();
    document.addEventListener("shopify:section:load", (event) => initTechnologyPins(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-tech-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTechnologyStories = (scope = document) => {
      scope.querySelectorAll("[data-ht-story]").forEach((story) => {
        if (story.dataset.htReady === "true") return;
        story.dataset.htReady = "true";
      });

      if (window.__hibanaTechnologyStoryListener) return;
      window.__hibanaTechnologyStoryListener = true;
      let ticking = false;

      const update = () => {
        if (window.innerWidth < 1200) {
          ticking = false;
          return;
        }
        const header = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--ht-header-offset")) || 0;
        const nav = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--ht-nav-height")) || 0;
        const focusLine = header + nav + ((window.innerHeight - header - nav) * .5);
        document.querySelectorAll("[data-ht-story]").forEach((story) => {
          const cards = [...story.querySelectorAll("[data-ht-story-card]")];
          const layers = [...story.querySelectorAll("[data-ht-story-media]")];
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const distance = Math.abs((rect.top + (rect.height * .5)) - focusLine);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });
          layers.forEach((layer, index) => layer.classList.toggle("is-active", index === nearestIndex));
        });
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate, { passive: true });
      update();
    };
    initTechnologyStories();
    document.addEventListener("shopify:section:load", (event) => initTechnologyStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-technology-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (explorer) => {
      if (explorer.dataset.hibanaExplorerReady) return;
      explorer.dataset.hibanaExplorerReady = 'true';
      explorer.querySelectorAll('[data-hibana-explorer-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.hibanaExplorerTab;
          explorer.querySelectorAll('[data-hibana-explorer-tab]').forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
          });
          explorer.querySelectorAll('[data-hibana-explorer-panel]').forEach((panel) => {
            const selected = panel.dataset.hibanaExplorerPanel === id;
            panel.hidden = !selected;
            panel.classList.toggle('is-active', selected);
          });
        });
      });
    };
    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-hibana-technology-explorer]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-technology-immersive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const initTechnology = (root) => {
      if (!root || root.dataset.hiTechReady === "true") return;
      root.dataset.hiTechReady = "true";
      root.classList.add("is-enhanced");

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const navLinks = [...root.querySelectorAll("[data-hi-tech-nav]")];
      const sections = [...root.querySelectorAll("[data-hi-tech-section]")].filter((section) => section.id);
      const revealItems = [...root.querySelectorAll("[data-hi-tech-reveal]")];
      const pins = [...root.querySelectorAll("[data-hi-tech-pin]")];
      const stories = [...root.querySelectorAll("[data-hi-tech-story]")];
      const mobileNav = root.querySelector("[data-hi-tech-mobile-nav]");
      const currentLabel = root.querySelector("[data-hi-tech-current]");
      let ticking = false;

      const setActiveNavigation = (id) => {
        let activeText = "";
        navLinks.forEach((link) => {
          const isActive = link.getAttribute("href") === `#${id}`;
          if (isActive) activeText = link.textContent.trim();
          if (isActive) link.setAttribute("aria-current", "true");
          else link.removeAttribute("aria-current");
        });
        if (currentLabel && activeText) currentLabel.textContent = activeText;
      };

      const updatePins = () => {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        pins.forEach((pin) => {
          if (reduceMotion || window.innerWidth < 990) {
            pin.style.setProperty("--hi-pin-progress", "1");
            pin.style.setProperty("--hi-pin-copy-opacity", "1");
            pin.style.setProperty("--hi-pin-height", "100%");
            pin.style.setProperty("--hi-pin-width", "100%");
            pin.style.setProperty("--hi-pin-top", "0%");
            pin.style.setProperty("--hi-pin-scale", "1");
            pin.style.setProperty("--hi-pin-shade-opacity", "1");
            pin.style.setProperty("--hi-pin-copy-y", "-30%");
            return;
          }
          const rect = pin.getBoundingClientRect();
          const distance = Math.max(pin.offsetHeight - viewportHeight, 1);
          const progress = clamp(-rect.top / distance, 0, 1);
          const copyOpacity = clamp((progress - .38) / .32, 0, 1);
          pin.style.setProperty("--hi-pin-progress", progress.toFixed(4));
          pin.style.setProperty("--hi-pin-copy-opacity", copyOpacity.toFixed(4));
          pin.style.setProperty("--hi-pin-height", `${72 + (28 * progress)}%`);
          pin.style.setProperty("--hi-pin-width", `${58 + (42 * progress)}%`);
          pin.style.setProperty("--hi-pin-top", `${14 - (14 * progress)}%`);
          pin.style.setProperty("--hi-pin-scale", (1.08 - (.08 * progress)).toFixed(4));
          pin.style.setProperty("--hi-pin-shade-opacity", (.35 + (.65 * progress)).toFixed(4));
          pin.style.setProperty("--hi-pin-copy-y", `${-40 + (10 * progress)}%`);
        });
      };

      const updateStories = () => {
        if (window.innerWidth < 990) return;
        const viewportCenter = window.innerHeight * .52;
        stories.forEach((story) => {
          const cards = [...story.querySelectorAll("[data-hi-tech-story-card]")];
          const media = [...story.querySelectorAll("[data-hi-tech-story-media]")];
          if (!cards.length || !media.length) return;
          let activeIndex = 0;
          let smallestDistance = Number.POSITIVE_INFINITY;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const center = rect.top + rect.height / 2;
            const distance = Math.abs(center - viewportCenter);
            if (distance < smallestDistance) {
              smallestDistance = distance;
              activeIndex = index;
            }
          });
          media.forEach((item, index) => item.classList.toggle("is-active", index === activeIndex));
        });
      };

      const updateActiveSection = () => {
        const marker = Math.min(window.innerHeight * .42, 360);
        let active = sections[0];
        sections.forEach((section) => {
          if (section.getBoundingClientRect().top <= marker) active = section;
        });
        if (active) setActiveNavigation(active.id);
      };

      const update = () => {
        updatePins();
        updateStories();
        updateActiveSection();
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      if ("IntersectionObserver" in window && !reduceMotion) {
        const revealObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            });
          },
          { threshold: .16, rootMargin: "0px 0px -8% 0px" }
        );
        revealItems.forEach((item) => revealObserver.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add("is-visible"));
      }

      root.querySelectorAll("[data-hi-tech-video-toggle]").forEach((button) => {
        const media = button.closest(".hi-tech__media");
        const video = media ? media.querySelector("video") : null;
        if (!video) {
          button.hidden = true;
          return;
        }
        video.controls = false;
        if (reduceMotion) {
          video.pause();
          button.classList.add("is-paused");
          button.setAttribute("aria-label", button.dataset.playLabel || "");
          const label = button.querySelector("[data-hi-tech-motion-label]");
          if (label) label.textContent = button.dataset.playLabel || "";
        }
        button.addEventListener("click", async () => {
          const label = button.querySelector("[data-hi-tech-motion-label]");
          if (video.paused) {
            try {
              await video.play();
              button.classList.remove("is-paused");
              button.setAttribute("aria-label", button.dataset.pauseLabel || "");
              if (label) label.textContent = button.dataset.pauseLabel || "";
            } catch (error) {
              button.classList.add("is-paused");
            }
          } else {
            video.pause();
            button.classList.add("is-paused");
            button.setAttribute("aria-label", button.dataset.playLabel || "");
            if (label) label.textContent = button.dataset.playLabel || "";
          }
        });
      });

      navLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          const selector = link.getAttribute("href");
          const target = selector ? root.querySelector(selector) : null;
          if (target) {
            event.preventDefault();
            target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
          }
          if (mobileNav) mobileNav.removeAttribute("open");
        });
      });

      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate, { passive: true });
      update();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll("[data-hi-tech-root]").forEach(initTechnology);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll());
    } else {
      initAll();
    }

    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hibana-technology-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (nav) => {
      if (nav.dataset.hibanaNavigationReady || !('IntersectionObserver' in window)) return;
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const targets = links.map((link) => document.getElementById(link.getAttribute('href').slice(1))).filter(Boolean);
      if (!targets.length) return;
      nav.dataset.hibanaNavigationReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`));
      }, { rootMargin: '-35% 0px -55% 0px', threshold: [0.01, 0.2, 0.5] });
      targets.forEach((target) => observer.observe(target));
    };
    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-hibana-technology-nav]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-upgrades-finder"] && !Shopify.designMode) return;
  try {
    
(()=>{const q=(e,s)=>e.querySelector(s),o=(s,a,t='n')=>{s.disabled=!a.length;a.forEach(i=>s.add(new Option(i[t]||i.n||i.h,i.k)))},ph=(e,k,d)=>e.dataset[k]||d;document.querySelectorAll('[data-vehicle-finder]').forEach(e=>{if(e.dataset.ready)return;e.dataset.ready=1;let d=JSON.parse(q(e,'[data-json]').textContent||'{}'),f=q(e,'[data-form]'),ma=q(e,'[data-make]'),mo=q(e,'[data-model]'),yr=q(e,'[data-year]'),va=q(e,'[data-variant]'),m=q(e,'[data-message]'),r=(s,t)=>{s.innerHTML='';s.add(new Option(t,''))},msg=t=>{m.textContent=t;m.hidden=!t},u=h=>h?e.dataset.prefix+'/'+h:'';o(ma,(d.makes||[]).sort((a,b)=>(a.n||'').localeCompare(b.n||'')));ma.onchange=()=>{msg('');r(mo,ph(e,'modelPlaceholder','Choose model'));r(yr,ph(e,'yearPlaceholder','Choose year'));r(va,ph(e,'variantPlaceholder','Choose variant'));yr.disabled=va.disabled=1;o(mo,(d.models||[]).filter(i=>i.mk===ma.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};mo.onchange=()=>{msg('');r(yr,ph(e,'yearPlaceholder','Choose year'));r(va,ph(e,'variantPlaceholder','Choose variant'));va.disabled=1;o(yr,(d.years||[]).filter(i=>i.mk===mo.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};yr.onchange=()=>{msg('');r(va,ph(e,'variantPlaceholder','Choose variant'));o(va,(d.variants||[]).filter(i=>i.yk===yr.value).sort((a,b)=>(a.n||'').localeCompare(b.n||'')))};f.onsubmit=t=>{t.preventDefault();let make=(d.makes||[]).find(i=>i.k===ma.value),v=(d.variants||[]).find(i=>i.k===va.value);if(!make||!mo.value||!yr.value||!v)return msg(ph(e,'validationMessage','Choose a make, model, year, and variant.'));location.href=v.u||u(make.h)}})})();

  } catch(e) { console.error(e); }
})();
})();
